import { AwsUi } from '../../../../core/runtime/src';
import { FormField } from '../../../form-field/src';
import { RadioGroup } from '../../../radio/src';
import { getCollectionComponent, getPreferencesController, renderSafely } from '../utility';
var _a = AwsUi.__addComponents(['awsui-table-page-size-selector', 'awsui-cards-page-size-selector'], {
    releaseStatus: 'stable',
    properties: {
        // Displayed on top of the component within preferences.
        title: {
            type: 'string'
        },
        // Array of options that the user can choose from. Example:
        // ```
        // [{
        //    value: 10,
        //    label: "10 resources"
        // }, {
        //    value: 30,
        //    label: "30 resources"
        // }]
        // ```
        options: {
            type: 'array',
            itemTypes: ['TablePageSizeSelector.Option']
        },
        // Internal property, used to maintain state between options change and confirm action.
        // Also is pupulated by main controller when pageSize is changed from pagination component.
        __pageSize: {
            type: 'integer'
        }
    },
    callbacks: {
        attached: function () {
            var _this = this;
            // register self with collection controller, so it will know about it when updating page size
            this.__parentComponent = getCollectionComponent(this.node);
            this.__parentComponent.__controller.pageSizeSelector = this;
            this.__pageSize = this.__parentComponent.__controller.getPageSize();
            this.__preferencesController = getPreferencesController(this.node);
            this.__preferencesListener = {
                onConfirm: function () {
                    _this.__parentComponent.__controller.setPageSize(_this.__pageSize, true);
                },
                onCancel: function () {
                    _this.__pageSize = _this.__parentComponent.__controller.getPageSize();
                    _this.__update();
                }
            };
            this.__preferencesController.addListener(this.__preferencesListener);
        },
        detached: function () {
            if (this.__parentComponent) {
                this.__parentComponent.__controller.pageSizeSelector = null;
            }
            if (this.__preferencesController) {
                this.__preferencesController.removeListener(this.__preferencesListener);
            }
        }
    },
    render: renderSafely(function () {
        var _this = this;
        var radioButtons = this.options.map(function (option) { return ({
            value: option.value.toString(),
            label: function () { return option.label; }
        }); });
        var onSelectionChange = function (event) {
            _this.__pageSize = parseInt(event.detail.value, 10);
        };
        var radioGroup = (AwsUi.__createElement(RadioGroup, { value: this.__pageSize && this.__pageSize.toString(), change: onSelectionChange, items: radioButtons }));
        return [AwsUi.__createElement(FormField, { label: this.title, control: radioGroup, stretch: true })];
    })
}), TablePageSizeSelector = _a[0], CardsPageSizeSelector = _a[1];
export { TablePageSizeSelector, CardsPageSizeSelector };
//# sourceMappingURL=index.js.map